import { useEffect, useCallback } from "react";
import IMeeting from "../../api/IMeeting";
import CONSTANTS from "../../contracts/Constants";
import { useMeetingStore } from "../../stores/useMeetingStore";
import useHubConnection from "./useHubConnection";

type UseMeetingChangeSocket = {
    meetingId: string;
};

const useMeetingChangeSocket = ({ meetingId }: UseMeetingChangeSocket) => {
    const setMeeting = useMeetingStore((state) => state.setMeeting);

    // 👇 改进：使用 useCallback 稳定函数引用
    const onMeetingChange = useCallback((changedId: string, newMeeting: IMeeting) => {
        console.log(`MeetingChanged event received for meeting: ${changedId}`);

        // 👇 添加 meetingId 验证和日志
        if (meetingId !== changedId) {
            console.warn(`Meeting ID mismatch. Expected: ${meetingId}, Received: ${changedId}`);
            return;
        }

        console.log(`Updating meeting state:`, {
            votingRound: newMeeting.votingRound,
            votingOn: newMeeting.votingOn,
            participantsCount: newMeeting.participants?.length,
            timestamp: new Date().toISOString()
        });

        setMeeting(newMeeting);
    }, [meetingId, setMeeting]); // 👈 确保依赖正确

    const hubConnectionRef = useHubConnection(
        CONSTANTS.SocketUrl + `?meetingId=${meetingId}`,
        (hubConnection) => {
            // 👇 改进：先移除旧的监听器再添加新的
            hubConnection.off("MeetingChanged");
            hubConnection.on("MeetingChanged", onMeetingChange);

            console.log(`SignalR listeners setup for meeting: ${meetingId}`);
        },
        () => {
            // 👇 连接成功后的回调（可选）
            console.log(`Connected to meeting hub for: ${meetingId}`);
        }
    );

    // 👇 添加清理日志
    useEffect(() => {
        return () => {
            console.log(`Cleaning up SignalR listeners for meeting: ${meetingId}`);
        };
    }, [meetingId]);

    return;
};

export default useMeetingChangeSocket;